export enum AppointmentRole {
  PROVIDER = 'provider',
  STAFF = 'staff',
}
